import isNumber from './is-number';

const isOdd = function(num: any): boolean {
  return isNumber(num) && num % 2 !== 0;
};

export default isOdd;
